<template>
  <el-tooltip content="回到旧版导航" placement="right">
    <div class="enjoy-page-tag-box" @click="handleClick">
      <div class="content">旧版</div>
    </div>
  </el-tooltip>
</template>

<script>
import {
  baseUrlToIframeMicroUrl,
  getJumpFusionErpHome,
  goJumpFusionErpHome,
} from '@/services/microFeUtil'
import { setIsPageTagManualCookie } from '@/services/utils/modules/authBj'
export default {
  name: '',
  methods: {
    handleClick() {
      this.$sensors.setWebClick({ name: '页签:切回旧版' })
      // window.location.href = 'https://erp.qizhishangke.com'
      // 尝试进入对应的跳转融合页面, 其次降级为erp首页
      setIsPageTagManualCookie(0)
      const jumpFusionErpHomeUrl = getJumpFusionErpHome()
      const subUrl = baseUrlToIframeMicroUrl(window.location.href)
      window.location.href = subUrl || jumpFusionErpHomeUrl
    },
  },
}
</script>

<style lang="scss" scoped>
.enjoy-page-tag-box {
  // width: 48px;
  height: 24px;
  padding: 0 8px;
  line-height: 24px;
  background: rgba($B6, 0.3);
  color: #c2cadf;
  cursor: pointer;

  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;

  &:hover {
    background: rgba($B6, 0.4);
  }

  .content {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
